<div class="duna-user-groups-container">

  <mat-card class="header-card">
    <mat-card-header>
      <mat-card-title><h1>Brugergrupperinger</h1></mat-card-title>
      <mat-card-subtitle>
        Opret grupperinger og tildel organisationens brugere. Se vedligeholdelsesstatistik pr. gruppering.
      </mat-card-subtitle>
    </mat-card-header>
  </mat-card>

  <mat-card class="table-card">
    <div class="card-header-with-action">
      <div class="card-header-text">
        <span class="card-title">Grupperinger</span>
        <span class="card-subtitle">Organisationens brugergrupperinger</span>
      </div>
      <button mat-raised-button color="primary" (click)="openCreateDialog()">
        <mat-icon>add</mat-icon>
        Opret gruppering
      </button>
    </div>
    <mat-card-content>
      <app-dynamic-table
        #groupsTable
        [dynamicInput]="dynamicInput"
      ></app-dynamic-table>
    </mat-card-content>
  </mat-card>

</div>
